import dayjs from 'dayjs';
import type { DatePreset } from './types';

export const DEFAULT_DATE_PRESETS: DatePreset[] = [
  {
    id: 'last-30min',
    label: 'Last 30 minutes',
    getRange: () => ({
      startTime: dayjs().subtract(30, 'minutes').format('YYYY-MM-DDTHH:mm'),
      endTime: dayjs().format('YYYY-MM-DDTHH:mm'),
    }),
  },
  {
    id: 'last-1hour',
    label: 'Last hour',
    getRange: () => ({
      startTime: dayjs().subtract(1, 'hour').format('YYYY-MM-DDTHH:mm'),
      endTime: dayjs().format('YYYY-MM-DDTHH:mm'),
    }),
  },
  {
    id: 'last-4hours',
    label: 'Last 4 hours',
    getRange: () => ({
      startTime: dayjs().subtract(4, 'hours').format('YYYY-MM-DDTHH:mm'),
      endTime: dayjs().format('YYYY-MM-DDTHH:mm'),
    }),
  },
  {
    id: 'last-12hours',
    label: 'Last 12 hours',
    getRange: () => ({
      startTime: dayjs().subtract(12, 'hours').format('YYYY-MM-DDTHH:mm'),
      endTime: dayjs().format('YYYY-MM-DDTHH:mm'),
    }),
  },
  {
    id: 'last-24hours',
    label: 'Last 24 hours',
    getRange: () => ({
      startTime: dayjs().subtract(24, 'hours').format('YYYY-MM-DDTHH:mm'),
      endTime: dayjs().format('YYYY-MM-DDTHH:mm'),
    }),
  },
  {
    id: 'last-48hours',
    label: 'Last 48 hours',
    getRange: () => ({
      startTime: dayjs().subtract(48, 'hours').format('YYYY-MM-DDTHH:mm'),
      endTime: dayjs().format('YYYY-MM-DDTHH:mm'),
    }),
  },
  {
    id: 'last-7days',
    label: 'Last 7 days',
    getRange: () => ({
      startTime: dayjs().subtract(7, 'days').format('YYYY-MM-DDTHH:mm'),
      endTime: dayjs().format('YYYY-MM-DDTHH:mm'),
    }),
  },
  {
    id: 'custom',
    label: 'Custom Range',
    getRange: () => null as any,
  },
];
